import getCurrentPage from '@functions/getCurrentPage';

import I from '../types.ts';

const init: I['init'] = function () {
    const { storePages } = this.props;
    const currentPage = getCurrentPage({
        storePages,
        filter: (page) => page.parentName === 'public',
    });

    const page = document.querySelector(`.public__page._${currentPage}`);

    if (page) {
        const scrollArea =
            page.querySelector('.public__pageBox:not(._full)') ||
            page.querySelector('.public__innerPage._show') ||
            page.querySelector('.publicLegalHeader__page._show');

        if (scrollArea) {
            scrollArea.addEventListener('scroll', this.pageScroll);
        }
    }
};

export default init;
